<template>
  <v-dialog v-model="hgShowDialog" content-class="create-crl-dialog" persistent>
    <v-card class="card">
      <v-card-text>
        <h3 class="header">Name your new list</h3>
        <hg-list-name-form :hg-report-id="hgReportId" @cancel="cancel"/>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import ListNameForm from './ListNameForm.vue';

export default {
  name: 'hgNewCrlDialog',
  props: {
    hgShowDialog: {
      type: Boolean,
      required: true,
    },
    hgReportId: {
      type: String,
      required: true,
    },
  },
  components: {
    'hg-list-name-form': ListNameForm,
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../styles/vars/theme';

.header {
  border-bottom: solid 3px $theme-color-primary;
  margin-bottom: 30px;
  padding-bottom: 20px;
}

.card {
  padding: 30px;
}
</style>

<style lang="scss">
.create-crl-dialog {
    max-width: 650px;
    width: 80vw;
}

@media all and (min-width: 980px) {
  .create-crl-dialog {
    width: 50vw;
  }
}
</style>
